import React from "react";
import { Row, Col } from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import CustomerVehicleForm from "./CustomerVehicleAddUpdateForm";
import strings from "../../core/translate";

export default class CustomerVehiclesAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      loading: false,
      ...customerVehicleState,
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const { selectedCustomer } = this.props.match.params;
    const { selectedMake, selectedModel } =
      this.props.location.state || this.props.match.params;

    this.pathname = `customers/${selectedCustomer}/Vehicle`;
    const edit = this.props.location.data;
    if (edit) {
      this.setState({
        ...edit,
      });
    }
    this.fetchCodes();
    this.fetchEnergyOptions();
    this.fetchmakes();
    if (selectedMake) {
      this.setState({ selectedMake }, () => {
        this.fetchmodels();
      });
    }
    if (selectedModel) {
      this.setState({ selectedModel }, () => {
        this.fetchtrims();
      });
    }
  }

  handleInputChange = (input, name) => {
    if (name) {
      const newValue = input ? input.value : "";
      const trimmedValue =
        typeof newValue === "string" ? newValue.trim() : newValue;
      this.setState({
        [name]: trimmedValue,
      });
    } else if (input && input.target) {
      const { name, value } = input.target;
      const trimmedValue = typeof value === "string" ? value.trim() : value;
      this.setState({
        [name]: trimmedValue,
      });
    }
  };

  handleTextChange = (event) => {
    const { name, value } = event.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    this.setState({
      [name]: trimmedValue,
    });
  };

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const {
      id,
      isTrimSelected,
      selectedMake,
      selectedModel,
      trimId,
      year,
      plateNumber,
      selectedPlateCode,
      plateCode,
      energy,
      isGCC,
      vin,
      username,
      ...data
    } = this.state;

    let response;
    const { selectedMerchant, selectedCustomer } = this.props.location.state;

    try {
      if (id) {
        const payload = {
          ...data,
          plateNumber,
          vin,
          username,
          plateCode,
          energy,
        };
        response = await this.engine.updateItem(this.pathname, id, payload);
      } else {
        let postData = {
          makeId: selectedMake,
          modelId: selectedModel,
          trimId: isTrimSelected ? trimId : undefined,
          year,
          isGCC,
          vin,
          username,
          plateNumber,
          plateCode: plateCode,
          energy,
        };

        response = await this.engine.saveItem(this.pathname, postData);
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push({
          pathname: `/admin/customer_vehicles/${selectedCustomer}`,
          state: { selectedMerchant, selectedCustomer },
        });
      }
    } catch (err) {
      console.error("Submission error:", err);

      if (err.response && err.response.data && err.response.data.message) {
        const errorMessage = err.response.data.message.join(", ");
        alert(`Error: ${errorMessage}`);
      } else {
        alert(strings.error);
      }
    }

    this.setState({ loading: false });
  };

  render() {
    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <CustomerVehicleForm
              {...this.state}
              handleValidSubmit={this.handleValidSubmit}
              handleMakeSelect={this.handleMakeSelect}
              handleModelSelect={this.handleModelSelect}
              handleTrimSelect={this.handleTrimSelect}
              handleInputChange={this.handleInputChange}
              handleTextChange={this.handleTextChange}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export const customerVehicleState = {
  plateNumber: 0,
  makes: [],
  selectedMake: "",
  models: [],
  selectedModel: "",
  trims: [],
  trimId: "",
  username: "",
  plateCodeOptions: [],
  plateCode: "A",
  energyOptions: [],
  energy: "",
  isTrimSelected: false,
  isGCC: false,
};
